document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.HeadlineText__read-more').forEach((button) => {
    button.addEventListener('click', () => {
      const surroundingElem = button.closest('.HeadlineText--collapsed')!
      surroundingElem.classList.remove('HeadlineText--collapsed')
    })
  })
})
